/* eslint-disable */
import React, { useEffect, useState } from "react";
import Tooltip from "./Tooltip";
import { Grommet, Box, CheckBox, Grid, RadioButtonGroup, Select, Text } from "grommet";
import "./App.scss";
import { colorRamp, layerProps } from "./props";
import { MapContext } from "@urbica/react-map-gl";
import HeMapboxUrbica from "../../components/HeMapboxUrbica";
import { Source, Layer, FeatureState, Filter } from "@urbica/react-map-gl";
import ControlContainer from "../../components/HeMapboxUrbica/components/ControlContainer";
// import MapInfo from "../../components/HeMapboxUrbica/components/MapInfo";
import ZoomInWarning from "../../components/HeMapboxUrbica/components/ZoomInWarning";
import { grommet } from "grommet/themes";
import { deepMerge } from "grommet/utils";

const theme = deepMerge(grommet, {
    radioButton: {
        gap: "xsmall",
        size: "18px",
        hover: {
            border: {
                color: "dark-3",
            },
        },
        color: "dark-1",
        check: {
            color: "dark-1",
            background: {
                color: "light-1",
            },
        },
        icon: {
            size: "10px",
        },
    },
    checkBox: {
        icon: {
            size: "10px",
        },
        size: "18px",
        color: "light-1",
    },
    global: {
        focus: {
            border: {
                // remove the light green border from around selected components
                color: "text",
                size: "xsmall",
            },
        },
    },
});

const layerNames = ["county", "cousub", "place", "tribe"];

const App = () => {
    const [visibleLayer, set_visibleLayer] = useState("cousub");
    const [zoom, set_zoom] = useState(null);
    const [hoveredEventState, set_hoveredEventState] = useState(null);
    // const [zoomType, set_zoomType] = useState("manual");

    // useEffect(() => {
    //     const newZoom = zoom;
    //     if (zoomType === "auto") {
    //         let newVisibleLayer = visibleLayer;
    //         layerNames.forEach((layerName) => {
    //             if (layerProps[layerName].minzoom < newZoom && newZoom <= layerProps[layerName].maxzoom) {
    //                 newVisibleLayer = layerName;
    //             }
    //         });
    //         if (newVisibleLayer !== visibleLayer) {
    //             set_visibleLayer(newVisibleLayer);
    //         }
    //     }
    // }, [zoom, visibleLayer, set_visibleLayer, zoomType]);

    const ZoomUpdater = () => {
        // allows for zoom to be updated after the map loads
        return (
            <MapContext.Consumer>
                {(map) => {
                    if (!zoom) {
                        map.on("zoomend", function () {
                            set_zoom(map.getZoom());
                        });
                        set_zoom(map.getZoom());
                    }
                    return;
                }}
            </MapContext.Consumer>
        );
    };

    const onLyrHover = (event, geoLevel) => {
        if (geoLevel !== visibleLayer) return;
        if (event.features.length === 0) return;
        if (!hoveredEventState || hoveredEventState.features[0].id !== event.features[0].id) {
            set_hoveredEventState(event);
        }
    };

    const onLyrLeave = (event, geoLevel) => {
        if (geoLevel !== visibleLayer) return;
        if (hoveredEventState) {
            set_hoveredEventState(null);
        }
    };

    const Legend = () => {
        const lp = layerProps[visibleLayer];
        return (
            <ControlContainer position="lower-left" style={{ padding: "0px" }}>
                <Box
                    background={{ color: "dark-1" }}
                    pad={{ horizontal: "medium", vertical: "small" }}
                    gap="small"
                    elevation="large"
                    border={{ color: "#444", size: "xsmall", style: "solid" }}
                >
                    <Box>
                        <Text size={"medium"} weight="bold" textAlign="center">
                            Rural Capacity Index
                        </Text>
                    </Box>
                    <Box direction="row-reverse" justify="center">
                        <Box pad={{ horizontal: "small" }}>
                            <label>Higher</label>
                        </Box>
                        <Box direction="row" align="center" gap="small">
                            <svg viewBox="0 0 16 16" width="16" height="16">
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    style={{
                                        fill: "rgba(247,147,30,0.05)",
                                        strokeWidth: 1,
                                        stroke: "rgba(247,147,30,0.05)",
                                    }}
                                />
                            </svg>
                        </Box>
                        <Box direction="row" align="center" gap="small">
                            <svg viewBox="0 0 16 16" width="16" height="16">
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    style={{ fill: colorRamp[3], strokeWidth: 1, stroke: colorRamp[3] }}
                                />
                            </svg>
                        </Box>
                        <Box direction="row" align="center" gap="small">
                            <svg viewBox="0 0 16 16" width="16" height="16">
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    style={{ fill: colorRamp[2], strokeWidth: 1, stroke: colorRamp[2] }}
                                />
                            </svg>
                        </Box>
                        <Box direction="row" align="center" gap="small">
                            <svg viewBox="0 0 16 16" width="16" height="16">
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    style={{ fill: colorRamp[1], strokeWidth: 1, stroke: colorRamp[1] }}
                                />
                            </svg>
                        </Box>
                        <Box direction="row" align="center" gap="small">
                            <svg viewBox="0 0 16 16" width="16" height="16">
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="15"
                                    height="15"
                                    style={{ fill: colorRamp[0], strokeWidth: 1, stroke: colorRamp[0] }}
                                />
                            </svg>
                        </Box>
                        <Box pad={{ horizontal: "small" }}>
                            <label>Lower</label>
                        </Box>
                    </Box>
                </Box>
            </ControlContainer>
        );
    };

    const LayerSwitch = () => {
        return (
            <ControlContainer position="top-left" style={{ padding: "0px" }}>
                <Box
                    background={{ color: "dark-1" }}
                    pad="small"
                    elevation="large"
                    border={{ color: "#444", size: "xsmall", style: "solid" }}
                >
                    <Box>
                        <Text size={"medium"} weight="bold" margin={{ bottom: "small" }}>
                            {" "}
                            Map Display
                        </Text>
                    </Box>
                    <Text></Text>
                    <RadioButtonGroup
                        // disabled={zoomType === "auto"}
                        name="layerswitch"
                        options={layerNames.map((l) => {
                            return {
                                label: layerProps[l].label,
                                value: l,
                            };
                        })}
                        value={visibleLayer}
                        onChange={(event) => set_visibleLayer(event.target.value)}
                    />
                    {/* <CheckBox
                        checked={zoomType === "auto"}
                        pad={{ top: "small" }}
                        reverse
                        label="By zoom level"
                        onChange={(event) => set_zoomType(event.target.checked ? "auto" : "manual")}
                    /> */}
                </Box>
            </ControlContainer>
        );
    };

    return (
        <Grommet theme={theme}>
            <Box fill="horizontal" height="800px">
                <HeMapboxUrbica mapStyle="mapbox://styles/mapbox/dark-v10" scrollZoom={false}>
                    {/* <MapInfo position='top-right'/> */}
                    <ZoomUpdater />
                    <Tooltip hoveredEventState={hoveredEventState} />
                    <Legend />
                    <LayerSwitch />
                    <Source id={"rci_source"} type="vector" url={"mapbox://headmin.he-rural-capacity-with-rank-v2_2"} />
                    {visibleLayer != "county" && (
                        <ZoomInWarning zoomThreshhold={3} warningText="Zoom in to see all features" />
                    )}
                    <Layer
                        id={visibleLayer}
                        source-layer={visibleLayer}
                        source={"rci_source"}
                        type="fill"
                        before={"road-label"}
                        paint={layerProps[visibleLayer].paint}
                        onHover={(evt) => {
                            onLyrHover(evt, visibleLayer);
                        }}
                        onLeave={(evt) => {
                            onLyrLeave(evt, visibleLayer);
                        }}
                    />
                </HeMapboxUrbica>
            </Box>
        </Grommet>
    );
};

export default App;
